import { Injectable } from '@angular/core';
import { McticHttpClient, McticHttpParams, Page } from '@mctic/ng-core';
import { DeclaracaoRda } from '../shared/model/';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class DeclaracaoRdaService {

  private readonly endpoint = '/sepin-backend/rest/declaracao-rda/';

  constructor(private readonly http: McticHttpClient) {
  }

  obterDeclaracaoRda(idRda: number): Observable<DeclaracaoRda> {
    return this.http.get<DeclaracaoRda>(`${this.endpoint}rda/${idRda}`);
  }

  salvarDeclaracaoRda(declaracao: DeclaracaoRda) {
    return this.http.post(this.endpoint, declaracao);
  }

}
